var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page container"},[_c('div',{staticClass:"error-page__wrapper"},[_c('div',{staticClass:"error-page__header"},[_vm._t("heading")],2),_c('div',{staticClass:"error-page__image"},[_vm._t("image")],2),_c('div',{staticClass:"error-page__details"},[_vm._t("details")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }